import { render, staticRenderFns } from "./PlayerSelector.vue?vue&type=template&id=b3f81750&scoped=true&"
import script from "./PlayerSelector.vue?vue&type=script&lang=ts&"
export * from "./PlayerSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerSelector.vue?vue&type=style&index=0&id=b3f81750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f81750",
  null
  
)

export default component.exports